import axiosApi from 'modules/api'
import { GetTokenOrdersResponse } from 'pages/api/orders'

interface FetchTokenOrdersPayload {
  chainId: number
  token?: string // this will lookup for either sellToken/buyToken on orders
  sellToken?: string
  sellTokenParent?: string
  buyToken?: string
  buyTokenParent?: string
  maker?: string
}

const fetchTokenOrders = async ({
  chainId,
  token,
}: FetchTokenOrdersPayload) => {
  const { data } = await axiosApi.get<GetTokenOrdersResponse>('/orders', {
    params: {
      chainId,
      token,
    },
  })
  return data.orders
}

export default fetchTokenOrders
